import ScrollNavigation from '@resources/js/ScrollNavigation';

// скрол для навігації
new ScrollNavigation({
  menuItemsSelector: '.js-hotel-nav-item',
  blocksSelector: '.js-hotel-block'
});
